import { apiEndpoints } from "../shared/constants/api-constant";
import restApiService from "./restApiService";

export class userRepository {
  static GetCurrentUser = async (): Promise<any> => {
    let result: any = null;
    await restApiService
      .get(apiEndpoints.USER)
      .then((response) => {
        if (response.Status === 200) {
          result = response.data;
        }
      })
      .catch((error) => {
        console.log("exception on API call : " + error);
        result = error?.response?.data?.errorList[0];
      });
    return result;
  };
}
